export enum Events {
  WidgetShown = 'widget:shown',
  WidgetStepChanged = 'widget:details:changed',
}
